import { Controller } from 'react-hook-form'

import TextField from '@mui/material/TextField'

const validatePhoneNumber = value => {
  if (value === '') return true
  const _value = value.replace(/-/g, '')
  if (/[0-9]{10}/.test(_value) && [10].includes(_value.length)) return true
  if (/[0-9]{11}/.test(_value) && [11].includes(_value.length)) return true
  return false
}

const validatePostalCode = value => {
  if (value === '') return true
  const _value = value.replace(/-/g, '')
  return /[0-9]{7}/.test(_value) && _value.length === 7
}

export default function ContactInput({ control, disabled, errors, required = false }) {
  return (
    <>
      <Controller
        name="postalCode"
        control={control}
        rules={{ required, validate: validatePostalCode }}
        defaultValue=""
        render={({ field }) => (
          <TextField
            {...field}
            sx={{ mb: 2 }}
            label="郵便番号"
            disabled={disabled}
            placeholder="7桁の半角数字で入力してください"
            helperText={errors.postalCode && '7桁の半角数字で入力してください。'}
          />
        )}
      />
      <Controller
        name="address"
        control={control}
        rules={{ required }}
        defaultValue=""
        render={({ field }) => (
          <TextField
            {...field}
            sx={{ mb: 2 }}
            label="住所"
            disabled={disabled}
            helperText={errors.address && '必須項目です'}
          />
        )}
      />
      <Controller
        name="tel"
        control={control}
        rules={{ required, validate: validatePhoneNumber }}
        defaultValue=""
        render={({ field }) => (
          <TextField
            {...field}
            sx={{ mb: 2 }}
            label="電話番号"
            disabled={disabled}
            placeholder="半角数字で入力してください"
            helperText={errors.tel && '10 桁か 11 桁の半角数字で入力してください。'}
          />
        )}
      />
      <Controller
        name="department"
        control={control}
        rules={{ required: false }}
        defaultValue=""
        render={({ field }) => (
          <TextField
            {...field}
            sx={{ mb: 2 }}
            label="部署"
            disabled={disabled}
            helperText={errors.staff && '必須項目です'}
          />
        )}
      />
      <Controller
        name="title"
        control={control}
        rules={{ required: false }}
        defaultValue=""
        render={({ field }) => (
          <TextField {...field} sx={{ mb: 2 }} fullWidth label="役職" disabled={disabled} />
        )}
      />
      <Controller
        name="staff"
        control={control}
        rules={{ required }}
        defaultValue=""
        render={({ field }) => (
          <TextField
            {...field}
            sx={{ mb: 2 }}
            label="担当者名"
            disabled={disabled}
            helperText={errors.staff && '必須項目です'}
          />
        )}
      />
    </>
  )
}
